<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <PayoutEventSelect v-model="selectedBundleId" :items="payoutEvents" :loading="fetchingPayoutEvents" :error-messages="errorMessage" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup lang="ts">
import { useInjectSubmitForm } from '@shared/composables/action-dialog/useInjectSubmitForm';
import { router } from '@inertiajs/vue3';
import type { FormOptions } from '@shared/types/Form';
import { useOwnerRepository } from '@app/land-hold/owner/repositories/useOwnerRepository';
import PayoutEventSelect from '@app/purchase/bundle/components/molecules/PayoutEventSelect.vue';
import type { IPayoutEvent } from '@app/purchase/bundle/models/PayoutEvent.ts';

const props = defineProps({
    ownerId: {
        type: String,
        required: true,
    },
});

const selectedBundleId = ref<string | null>(null);
const errorMessage = ref('');

const { data: payoutEventsResponse, processing: fetchingPayoutEvents } = useOwnerRepository().query.listEligiblePayoutEvents(props.ownerId);
const payoutEvents = computed<IPayoutEvent[]>(() => payoutEventsResponse.value?.data ?? []);

function execute(options: FormOptions): void {
    if (!selectedBundleId.value) {
        errorMessage.value = 'Please select a payout event.';
        return;
    }

    errorMessage.value = '';
    options.onStart?.();

    router.post(
        route('bundles.add-owners', { id: selectedBundleId.value }),
        { owner_ids: [props.ownerId] },
        {
            onSuccess: (page) => {
                options.onSuccess?.(page);
            },
            onError: (errors) => {
                errorMessage.value = Object.values(errors).flat().join(', ') || 'Failed to add owner to payout event.';
            },
            onFinish: (visit) => {
                options.onFinish?.(visit);
            },
        },
    );
}

useInjectSubmitForm(execute);
</script>
